import { render, staticRenderFns } from "./WashProductCategory.vue?vue&type=template&id=3869456a&scoped=true&"
import script from "./WashProductCategory.vue?vue&type=script&lang=js&"
export * from "./WashProductCategory.vue?vue&type=script&lang=js&"
import style0 from "./WashProductCategory.vue?vue&type=style&index=0&id=3869456a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3869456a",
  null
  
)

export default component.exports